<div class="daily-report-form">
    <!-- Header Fields -->
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="dailyDateTime">Date/Time</label>
                <wj-input-date-time
                    [(ngModel)]="dailyReport().dateTime"
                    name="dailyDateTime"
                    id="dailyDateTime"
                    [isRequired]="false"
                ></wj-input-date-time>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="dailyOperatorName">Operator Name</label>
                <wj-combo-box
                    [(ngModel)]="dailyReport().operatorName"
                    name="dailyOperatorName"
                    id="dailyOperatorName"
                    [itemsSource]="employeeOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="dailyJobName">Job</label>
                <wj-combo-box
                    [(ngModel)]="dailyReport().jobName"
                    name="dailyJobName"
                    id="dailyJobName"
                    [itemsSource]="jobOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="dailyEquipmentId">Equipment ID / Unit #</label>
                <wj-combo-box
                    [(ngModel)]="dailyReport().equipmentId"
                    name="dailyEquipmentId"
                    id="dailyEquipmentId"
                    [itemsSource]="equipmentOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
    </div>

    <p class="checklist-instructions">Check ONLY if there is a problem — leave as OK if no issue.</p>

    <!-- Pre-Start Walk-Around -->
    <div class="checklist-section">
        <h6 class="checklist-heading" [class.has-minor]="hasMinor(dailyReport().preStartWalkAround)" [class.has-critical]="hasCritical(dailyReport().preStartWalkAround)">Pre-Start Walk-Around</h6>
        <div class="row">
            @for (item of dailyReport().preStartWalkAround; track item.label; let i = $index) {
                <div class="col-sm-6 col-12">
                    <div class="checklist-row">
                        <span class="checklist-label">{{ item.label }}</span>
                        <wj-combo-box
                            [(ngModel)]="item.status"
                            [name]="'preStart_' + i"
                            [itemsSource]="statusOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            }
        </div>
    </div>

    <!-- Safety Equipment -->
    <div class="checklist-section">
        <h6 class="checklist-heading" [class.has-minor]="hasMinor(dailyReport().safetyEquipment)" [class.has-critical]="hasCritical(dailyReport().safetyEquipment)">Safety Equipment</h6>
        <div class="row">
            @for (item of dailyReport().safetyEquipment; track item.label; let i = $index) {
                <div class="col-sm-6 col-12">
                    <div class="checklist-row">
                        <span class="checklist-label">{{ item.label }}</span>
                        <wj-combo-box
                            [(ngModel)]="item.status"
                            [name]="'safety_' + i"
                            [itemsSource]="statusOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            }
        </div>
    </div>

    <!-- Engine / Operation -->
    <div class="checklist-section">
        <h6 class="checklist-heading" [class.has-minor]="hasMinor(dailyReport().engineOperation)" [class.has-critical]="hasCritical(dailyReport().engineOperation)">Engine / Operation</h6>
        <div class="row">
            @for (item of dailyReport().engineOperation; track item.label; let i = $index) {
                <div class="col-sm-6 col-12">
                    <div class="checklist-row">
                        <span class="checklist-label">{{ item.label }}</span>
                        <wj-combo-box
                            [(ngModel)]="item.status"
                            [name]="'engine_' + i"
                            [itemsSource]="statusOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            }
        </div>
    </div>

    <!-- Hydraulics / Attachments -->
    <div class="checklist-section">
        <h6 class="checklist-heading" [class.has-minor]="hasMinor(dailyReport().hydraulicsAttachments)" [class.has-critical]="hasCritical(dailyReport().hydraulicsAttachments)">Hydraulics / Attachments</h6>
        <div class="row">
            @for (item of dailyReport().hydraulicsAttachments; track item.label; let i = $index) {
                <div class="col-sm-6 col-12">
                    <div class="checklist-row">
                        <span class="checklist-label">{{ item.label }}</span>
                        <wj-combo-box
                            [(ngModel)]="item.status"
                            [name]="'hydraulics_' + i"
                            [itemsSource]="statusOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            }
        </div>
    </div>

    <!-- Work Area / Final Check -->
    <div class="checklist-section">
        <h6 class="checklist-heading" [class.has-minor]="hasMinor(dailyReport().workAreaFinalCheck)" [class.has-critical]="hasCritical(dailyReport().workAreaFinalCheck)">Work Area / Final Check</h6>
        <div class="row">
            @for (item of dailyReport().workAreaFinalCheck; track item.label; let i = $index) {
                <div class="col-sm-6 col-12">
                    <div class="checklist-row">
                        <span class="checklist-label">{{ item.label }}</span>
                        <wj-combo-box
                            [(ngModel)]="item.status"
                            [name]="'workArea_' + i"
                            [itemsSource]="statusOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            }
        </div>
    </div>

    <!-- Issue Details -->
    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <label for="dailyIssueDetails">Issue Details</label>
                <textarea
                    rows="3"
                    class="form-control"
                    [(ngModel)]="dailyReport().issueDetails"
                    name="dailyIssueDetails"
                    id="dailyIssueDetails"
                    placeholder="Describe any issues found..."
                ></textarea>
            </div>
        </div>
    </div>

    <!-- Equipment Status -->
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="dailyEquipmentStatus">Equipment Status</label>
                <wj-combo-box
                    [(ngModel)]="dailyReport().equipmentStatus"
                    name="dailyEquipmentStatus"
                    id="dailyEquipmentStatus"
                    [itemsSource]="equipmentStatusOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
    </div>
</div>
